// extracted by mini-css-extract-plugin
module.exports = {"inputPhoneNumber":"_9HBlYQIsqZB4svdfH1w6o","code":"jg7JKiCPAdHnrzFR7ajYG","number":"Tz4rsHE49AOubGL-cS9dR"};